import './entrypoint_processed.pcss'; ///..why?
import * as browser from "./browser";
import { invokeMethod } from "./library";
import { debounce } from "ts-debounce";
async function onResize() {
    await invokeMethodOnScripts("onResize");
    // Run background (if any) after the onresize scripts above
    const game = document.body.dataset["game"];
    console.log("Body data game is '" + game + "'");
    if (game)
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                import("./" + game + "/backgroundgen.ts").then(m => window.requestAnimationFrame(() => m.default()));
            });
        });
}
function loaders() {
    browser.interceptDOM();
    invokeMethodOnScripts("default");
    onResize();
    window.addEventListener('resize', debounce(onResize, 100));
}
async function invokeMethodOnScripts(name) {
    const scripts = document.getElementsByName("script-def");
    console.log("Detected " + scripts.length + " local scripts, running " + name + " hooks.");
    for (let i = 0; i < scripts.length; i++) {
        let script = scripts[i].content;
        console.log("Importing local script '" + script + "'");
        await (import("./" + script + "_rawscript.ts").then(m => invokeMethod(m, name)));
    }
}
if (document.readyState === "loading")
    document.addEventListener('DOMContentLoaded', loaders);
else
    loaders();
document.onkeydown = (keyDownEvent) => {
    if (keyDownEvent.key == 'b' && keyDownEvent.altKey)
        onResize();
};
